<template>

  <b-form class="mt-3" @submit="onSubmitForm">
    <b-row>

      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>

    </b-row>

    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        type="submit"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>

</template>

<script>
import {
  BButton, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import InputFilter from '../../../filters/components/InputFilter.vue'

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    vSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {

    const searchList = [
      {
        id: 'officer', label: 'ชื่อเจ้าหน้าที่', value: '', class: '', style: '', placeholder: 'กรอกชื่อเจ้าหน้าที่', type: 'text', options: [],
      },
    ]
  
    return {
      search: searchList,
      props,
    }
  },
  // mounted() {
  //   this.onSearchBtnClicked();
  // },
  methods: {
    onSubmitForm(e) {
      e.preventDefault();
      this.onSearchBtnClicked();
    },
    onResetBtnClicked() {
      this.search[0].value = null;
    },
    onSearchBtnClicked() {
      const params = {
        officerName: this.search[0].value
      };
      console.log("OfficerName", params);
      this.$emit("handleSubmit", params);
    },
  },
}
</script>
 <style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>
